/* tslint:disable */
/* eslint-disable */

/**
 * - `result`: `result` is the VoP result a payout would be made on.
 * - `in_progress`: the check did not end within the wait; ask again later.
 * - `off`: VoP is off in this environment.
 */
export enum PayeeVerificationStatus {
  Result = 'result',
  InProgress = 'in_progress',
  Off = 'off'
}
